import { Affix, Col, Row } from "antd";
import LoadingComponent from "components/LoadingComponent";
import { isRenderCancellationReason, isRenderImageLibrary } from "../helper";
import ButtonGroup from "./components/ButtonGroup";
import CancellationReason from "./components/CancellationReason";
import ImageLibrary from "./components/ImageLibrary";
import InfoAgent from "./components/InfoAgent";
import InfoProductAndBill from "./components/InfoProductAndBill";
import OrderCodeAndOrderStatus from "./components/OrderCodeAndOrderStatus";
import Toolbar from "./components/ToolBar";
import useDetail from "./useDetail";
import { useState, useEffect } from "react";
import ModalChangeWarehouse from "./components/ModalChangeWarehouse";

const Detail = () => {
  const {
    onExportOrder,
    onPrintOrder,
    dataToolBar,
    loading,
    dataOrderCodeAndOrderStatus,
    dataInfoAgent,
    dataInfoProductAndBill,
    dataButtonGroup,
    order,
    dataImageLibrary,
    dataCancellationReason,
    actions,
    canViewOrder,
    loadingPermission,
    refetchOrder,
  } = useDetail();
  const { status } = dataOrderCodeAndOrderStatus;

  const [visibleChangeWarehouse, setVisibleChangeWarehouse] = useState(false);
  const [selectedWarehouseID, setSelectedWarehouseID] = useState();

  useEffect(() => {
    if (order?.exportedWarehouseID) {
      setSelectedWarehouseID(order.exportedWarehouseID);
    }
  }, [order?.exportedWarehouseID]);

  const handleOpenChangeWarehouse = () => {
    setVisibleChangeWarehouse(true);
  };

  const handleConfirmChangeWarehouse = async () => {
    if (selectedWarehouseID && selectedWarehouseID !== order?.exportedWarehouseID) {
      await actions.onChangeWarehouse(selectedWarehouseID);
    }
    setVisibleChangeWarehouse(false);
  };

  return (
    <>
      <LoadingComponent loading={loading}>
        {!loadingPermission && canViewOrder && (
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Toolbar onExportOrder={onExportOrder} onPrintOrder={onPrintOrder} dataToolBar={dataToolBar} />
          </Col>

          <Col span={24}>
            <OrderCodeAndOrderStatus dataOrderCodeAndOrderStatus={dataOrderCodeAndOrderStatus} />
          </Col>

          {isRenderImageLibrary(status) && (
            <Col span={24}>
              <ImageLibrary dataImageLibrary={dataImageLibrary} />
            </Col>
          )}

          {isRenderCancellationReason(status) && (
            <Col span={24}>
              <CancellationReason dataCancellationReason={dataCancellationReason} />
            </Col>
          )}

          <Col span={24}>
            <InfoAgent
              dataInfoAgent={dataInfoAgent}
              order={order}
              handleOpenChangeWarehouse={handleOpenChangeWarehouse}
              onRefetch={refetchOrder}
            />
          </Col>

          <Col span={24}>
            <InfoProductAndBill dataInfoProductAndBill={dataInfoProductAndBill} />
          </Col>

          <Col span={24}>
            <Affix offsetBottom={10}>
              <ButtonGroup dataButtonGroup={dataButtonGroup} actions={actions} order={order} />
            </Affix>
          </Col>

        </Row>
      )}
    </LoadingComponent>
    <ModalChangeWarehouse
      loading={loading}
      order={order}
      visibleChangeWarehouse={visibleChangeWarehouse}
      setVisibleChangeWarehouse={setVisibleChangeWarehouse}
      selectedWarehouseID={selectedWarehouseID}
      setSelectedWarehouseID={setSelectedWarehouseID}
      handleConfirmChangeWarehouse={handleConfirmChangeWarehouse}
    />
  </>
  );
};

export default Detail;
